import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

import {analyticsClient} from '../../../../analytics-client';
import {appHistory} from '../../../../history';

import {getIconByCreatorOriginCategory, getNameByCreatorOriginCategory} from './helpers';
import type {CreatorOriginCategory, CreatorOriginCategoryValue} from './types';

import styles from './cell.module.css';

const recordAnalyticsEvent = (
    type: CreatorOriginCategory,
    label: string,
    creatorEntityId: string | null | undefined,
    threadId: string | null | undefined
) => {
    analyticsClient.track(analyticsClient.EVENTS.TRACK_ENGAGEMENT_LEAD_ACTION_CLICKED, {
        action_type: type,
        action_label: label,
        creator_entity_id: creatorEntityId,
        thread_id: threadId,
    });
};

interface Props {
    value: CreatorOriginCategoryValue;
}

export function CellCreatorOriginCategory(props: Props) {
    const {onOpen: onOpenSubmissionModal} = useOpenableModal(OpenableModals.FORM_SUBMISSION_MODAL, {
        submissionId: props.value?.submissionId,
    });

    const handleOpenActivityModal = () => {
        appHistory.replace({
            ...appHistory.location,
            hash: `/${props.value.activityId}`,
            state: {modal: true},
        });
    };

    if (!props.value?.category) {
        return null;
    }

    const Icon = getIconByCreatorOriginCategory(props.value.category);

    const content = (
        <Stack isHorizontal={true} spacing={8} alignItems='center'>
            {Icon && <Icon size={16} alignCenter={true} />}
            <Stack>
                {getNameByCreatorOriginCategory(props.value.category)}
                {props.value.category === 'chat_offline' && (
                    <Body color='light' size='mini'>
                        Offline form
                    </Body>
                )}
            </Stack>
        </Stack>
    );

    const renderContent = () => {
        if (props.value.submissionId || props.value.activityId) {
            return (
                <Link
                    size='small'
                    variant='primary'
                    onClick={(e) => {
                        e.stopPropagation();
                        if (props.value.activityId) {
                            handleOpenActivityModal();
                        } else if (props.value.submissionId) {
                            onOpenSubmissionModal();
                        }
                        recordAnalyticsEvent(
                            props.value.category,
                            getNameByCreatorOriginCategory(props.value.category),
                            props.value.submissionId,
                            props.value.threadId
                        );
                    }}
                >
                    {content}
                </Link>
            );
        }

        if (props.value.threadUrl) {
            return (
                <Link
                    newTab={true}
                    size='small'
                    variant='primary'
                    href={props.value.threadUrl}
                    onClick={(e) => {
                        e.stopPropagation();
                        recordAnalyticsEvent(
                            props.value.category,
                            getNameByCreatorOriginCategory(props.value.category),
                            null,
                            props.value.threadId
                        );
                    }}
                >
                    {content}
                </Link>
            );
        }

        return content;
    };

    return <div className={styles['cell-content']}>{renderContent()}</div>;
}
